module.exports = __webpack_public_path__ + "img/lead-generation.09d1c133.svg";